// firebase file upload
import { useState } from "react";
import firebase from "./firebase";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

import WebbProgressBar from "../comp/webb-progressbar";

const storage = getStorage();

export default function FirebaseFileSaver (props) {

  const [stat,setStatus] = useState('Select File...');
  const [done, setDone] = useState(0);
  const [link,setLink] = useState(props.avtr || 'https://firebasestorage.googleapis.com/v0/b/finnovate99.appspot.com/o/webb%2Ffilesave.png?alt=media&token=9acb1627-380a-48a6-b9b6-e174806a79ef' );

  const handleUpload = async (docx) => {

    setStatus('Please Wait... ')

    if (docx) {
      // console.log (docx)

      const filename = props.name + '-' + (new Date()).getTime().toString() 
      + '.' + docx.name.split('.')[(docx.name.split('.')).length-1]

      setLink('https://firebasestorage.googleapis.com/v0/b/finnovate99.appspot.com/o/webb%2Ffilesave.png?alt=media&token=9acb1627-380a-48a6-b9b6-e174806a79ef');

      const storageRef = ref(storage, props.name+'/'+filename);
      const uploadTask = uploadBytesResumable(storageRef, docx);

      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on('state_changed',
        (snapshot) => {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          setDone (Math.floor((snapshot.bytesTransferred / snapshot.totalBytes) * 100));
          setStatus('File Save ' + Math.floor((snapshot.bytesTransferred / snapshot.totalBytes) * 100) + '% done');

          switch (snapshot.state) {
            case 'paused':
              // console.log('File Save is paused');
              break;
            case 'running':
              // console.log('File Save is running');
              break;
          }
        }, 
        (error) => {
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case 'storage/unauthorized':
              // User doesn't have permission to access the object
              break;
            case 'storage/canceled':
              // User canceled the upload
              break;
            case 'storage/unknown':
              // Unknown error occurred, inspect error.serverResponse
              break;
          }
        }, 
        () => {
            // Upload completed successfully, now we can get the download URL
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            console.log('link:', downloadURL);
            setLink(downloadURL)
            // send url to parent
            props.link(downloadURL);
          });
          document.getElementById("file").value = null
        }
      );

    }
 
  }

  return (
  <>

    <div className="mb-3">
      <div className="form-group">
        <div className="layout-landscape mb-3 border rounded">
          <img
            className="ref"
            src={link}
            alt="Uploaded Images"
          />
        </div>
        
        <WebbProgressBar stat={done}/>
        <p className="small">{'Status: '}{stat}</p>
        

        <input 
          type="file" id="file"
          onChange= { (e) => {handleUpload(e.target.files[0]) }} 
        ></input>
      </div>
    </div>

    <div className="mb-3 d-none">
      <div className="form-group">
        <label className="form-label small">Link <span className="text-danger">*</span></label>
        <input type="text" className="form-control height-md bg-soft"
          value={link}
          onChange={({ target }) => {
            setStatus('External Link... ');
            setLink(target.value); 
            props.link(target.value)
          }}
          placeholder="Image Link">
        </input>
      </div>
    </div>

  </>
  )
}